import { render, staticRenderFns } from "./project-filter.vue?vue&type=template&id=47046a72"
import script from "./project-filter.vue?vue&type=script&lang=js"
export * from "./project-filter.vue?vue&type=script&lang=js"
import style0 from "./project-filter.vue?vue&type=style&index=0&id=47046a72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports